import { render, staticRenderFns } from "./ManifestImportFilters.vue?vue&type=template&id=24703a74&scoped=true"
import script from "./ManifestImportFilters.vue?vue&type=script&lang=js"
export * from "./ManifestImportFilters.vue?vue&type=script&lang=js"
import style0 from "./ManifestImportFilters.vue?vue&type=style&index=0&id=24703a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24703a74",
  null
  
)

export default component.exports